import React, { FunctionComponent } from 'react';
import JsonData from '@components/JsonData';
import { IBaseSchema } from '@schemas/types';
import seoDataSchema from '@schemas/data-schema.json';
import seoUiSchema from '@schemas/ui-schema.json';
import useSession from '@hooks/useSessions';
import { useRouter } from 'next/router';

const SeoEditComponent: FunctionComponent = () => {
  const { user } = useSession();
  const router = useRouter();

  return (
    <>
      {user?.isAdmin && <div style={{ position: 'absolute', top: 60, left: 10, zIndex: 10 }}>
        <JsonData<IBaseSchema>
          context={`${router.asPath.replaceAll('/', '.')}_seo`}
          schema={seoDataSchema}
          uiSchema={seoUiSchema}
          editable={user?.isAdmin || false}
        >
          {() => <></>}
        </JsonData>
      </div>}
    </>
)
}

export default SeoEditComponent;
